import React, { Component } from "react";
import ModalImage from "react-modal-image";
import noimage from "./../asset/images/noimage.png";
import CustomButton from "./CustomButton";
import plus from "./../asset/images/plus.svg";
import minus from "./../asset/images/minus.svg";
import { NumericFormat } from "react-number-format";
import { word } from "../words.js";

export default class Item extends Component {
  constructor(props) {
    super(props);

    let q = 0;

    this.props.currentOrder.forEach((element) => {
      if (element.id === this.props.id) {
        if (element.quantity !== undefined && element.quantity !== null)
          q = element.quantity;
      }
    });

    this.state = {
      width: false,
      quantity: q,
      title: "",
      des: "",
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidUpdate(prvProps) {
    if (prvProps.currentOrder !== this.props.currentOrder) {
      let q = 0;

      this.props.currentOrder.forEach((element) => {
        if (element.id === this.props.id) {
          if (element.quantity !== undefined && element.quantity !== null)
            q = element.quantity;
        }
      });

      this.setState({ quantity: q });
    }

    if (
      prvProps.nameObj !== this.props.nameObj ||
      prvProps.currentLang !== this.props.currentLang
    ) {
      this.updateInfo();
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);

    this.updateInfo();
  }

  updateInfo() {
    let title = "";
    let des = "";
    this.props.nameObj.forEach((element) => {
      if (element.languageId === this.props.currentLang.languageId) {
        title = element.name;
      }
    });

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (element.languageId === this.props.defaultLangId) {
          title = element.name;
        }
      });
    }

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (title === "") {
          title = element.name;
        }
      });
    }

    this.props.descrObj.forEach((element) => {
      if (element.languageId === this.props.currentLang.languageId) {
        des = element.descr;
      }
    });

    if (des === "") {
      this.props.descrObj.forEach((element) => {
        if (element.languageId === this.props.defaultLangId) {
          des = element.descr;
        }
      });
    }

    if (des === "") {
      this.props.descrObj.forEach((element) => {
        if (title === "") {
          des = element.descr;
        }
      });
    }

    this.setState({ title: title, description: des });
  }

  updateWindowDimensions() {
    try {
      this.setState({ width: window.innerWidth });
      if (window.innerWidth < 440) {
      }
    } catch (error) {}
  }

  minusClick() {
    if (this.state.quantity > 0)
      this.setState({ quantity: this.state.quantity - 1 }, () => {
        this.ChangeOrder();
      });
  }

  plusClick() {
    this.setState({ quantity: this.state.quantity + 1 }, () => {
      this.ChangeOrder();
    });
  }

  ChangeOrder() {
    // let data={
    //     id:this.props.id,
    //     quantity:this.state.quantity,
    // }

    let item = JSON.parse(JSON.stringify(this.props.foodItem));

    item.quantity = this.state.quantity;

    this.props.ChangeOrder(item, true);
  }

  render() {
    if (this.state.width > 474 && !this.props.isShoppingItem) {
      return (
        <div className="fiObjectContainer">
          <div className="fiObjectItem">
            <div
              style={{
                position: "relative",
                height: "40%",
                objectFit: "cover",
                backgroundColor: "white",
                overflow: "hidden",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              {(this.props.img2 === "" ||
                this.props.img2 === null ||
                this.props.img2 === undefined) && (
                <img src={noimage} alt="" className="itemImage-noexist" />
              )}
              {this.props.img2 !== "" &&
                this.props.img2 !== null &&
                this.props.img2 !== undefined && (
                  <ModalImage
                    hideDownload
                    className="itemImage-exist"
                    small={
                      "https://api.sepandplus.ontco.com/api/public/" +
                      this.props.img2
                    }
                    large={
                      "https://api.sepandplus.ontco.com/api/public/" +
                      this.props.img1
                    }
                    alt={this.state.title}
                    imageBackgroundColor="white"
                  />
                )}
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                marginTop: "5px",
              }}
            >
              {/* <div className="fiObjectTitle">{this.props.title}</div> */}
              <div
                className={
                  this.props.currentLang.direction === "rtl"
                    ? "fiObjectTitle IRANSansMobileBoldFont"
                    : "fiObjectTitle SFUIDisplayBoldFont"
                }
              >
                {this.state.title}
              </div>
            </div>

            {/* <div style={{minHeight:'1px',width:'100%',backgroundColor:'var(--gray4)'}}/> */}

            <div
              style={{
                flex: "1",
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                padding: "5px 0px",
                overflow: "hidden",
              }}
            >
              {this.state.description !== "" && (
                <div className="foodItemSmallDes">{this.state.description}</div>
              )}
              {this.state.description === "" && (
                <div
                  className="foodItemSmallDes"
                  style={{ fontStyle: "italic", color: "var(--gray3)" }}
                >
                  {word[this.props.currentLang.tag]["noDescription"]}
                </div>
              )}
            </div>

            <div
              style={{
                minHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
                position: "relative",
              }}
            >
              <div className="descriptionShadow" />
              <div
                style={{
                  minHeight: "1px",
                  width: "100%",
                  backgroundColor: "var(--gray4)",
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                }}
              />
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "5px 0px",
              }}
            >
              <div
                className={
                  this.props.currentLang.direction === "rtl"
                    ? "fiObjectPrice IRANSansMobileBoldFont"
                    : "fiObjectPrice SFUIDisplayBoldFont"
                }
              >
                <NumericFormat
                  allowNegative={true}
                  value={this.props.price}
                  displayType={"text"}
                  thousandSeparator={true}
                />
                &nbsp;{this.props.unit}
              </div>
            </div>

            {this.state.quantity > 0 && this.props.isTable && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "5px",
                  direction: "ltr",
                }}
              >
                <div
                  className="plusminus"
                  style={{ width: "30%", height: "31px" }}
                  onClick={this.minusClick.bind(this)}
                >
                  <img
                    src={minus}
                    style={{
                      width: "55%",
                      height: "2px",
                      objectFit: "contain",
                    }}
                    alt=""
                  />
                </div>
                <div style={{ width: "2px" }} />
                <div
                  style={{ minWidth: "25px", maxWidth: "25px" }}
                  className={
                    this.props.currentLang.direction === "rtl"
                      ? "orderItemCount IRANSansMobileFont"
                      : "orderItemCount SFUIDisplayFont"
                  }
                >
                  {this.state.quantity !== undefined ? this.state.quantity : 0}
                </div>
                <div style={{ width: "2px" }} />
                <div
                  className="plusminus"
                  style={{ width: "30%", height: "31px" }}
                  onClick={this.plusClick.bind(this)}
                >
                  <img
                    src={plus}
                    style={{
                      width: "55%",
                      height: "55%",
                      objectFit: "contain",
                    }}
                    alt=""
                  />
                </div>
              </div>
            )}

            {this.state.quantity === 0 && this.props.isTable && (
              <div style={{ width: "100%", marginTop: "5px" }}>
                <CustomButton
                  title={word[this.props.currentLang.tag]["order"]}
                  minHeight="30px"
                  img={null}
                  onClick={this.plusClick.bind(this)}
                />
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div
          className={
            this.props.currentLang.direction === "rtl"
              ? "foodItemSmall IRANSansMobileBoldFont"
              : "foodItemSmall SFUIDisplayBoldFont"
          }
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "70px",
              // backgroundColor: "red",
              width: "70px",
              minWidth: "70px",
              maxWidth: "70px",
              position: "relative",
              // minWidth:
              //   this.props.isShoppingItem && this.state.width > 474
              //     ? "100px"
              //     : "90px",
              // maxWidth:
              //   this.props.isShoppingItem && this.state.width > 474
              //     ? "100px"
              //     : "90px",
              // width:
              //   this.props.isShoppingItem && this.state.width > 474
              //     ? "100px"
              //     : "90px",
            }}
          >
            {(this.props.img2 === "" ||
              this.props.img2 === null ||
              this.props.img2 === undefined) && (
              <img src={noimage} alt="" className="itemImage-noexist" />
            )}
            {this.props.img2 !== "" &&
              this.props.img2 !== null &&
              this.props.img2 !== undefined && (
                <ModalImage
                  hideDownload
                  className="itemImage-exist"
                  small={
                    "https://api.sepandplus.ontco.com/api/public/" +
                    this.props.img2
                  }
                  large={
                    "https://api.sepandplus.ontco.com/api/public/" +
                    this.props.img1
                  }
                  alt={this.state.title}
                  imageBackgroundColor="white"
                />
              )}
            {/* <div
              style={{
                height: "100%",
                width: "100%",
                maxHeight:
                  this.props.isShoppingItem && this.state.width > 474
                    ? "100px"
                    : "90px",
                minHeight:
                  this.props.isShoppingItem && this.state.width > 474
                    ? "100px"
                    : "90px",
                height:
                  this.props.isShoppingItem && this.state.width > 474
                    ? "100px"
                    : "90px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
              }}
            >

              
            </div> */}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: "1",
              justifyContent: "space-between",
              width: "100%",
              marginLeft:
                this.props.currentLang.direction === "rtl" ? "0px" : "5px",
              marginRight:
                this.props.currentLang.direction === "rtl" ? "5px" : "0px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                // backgroundColor: "red",
                // height: "44%",
              }}
            >
              <div
                className="foodItemSmallTitle"
                style={{
                  fontSize:
                    this.props.isShoppingItem && this.state.width > 474
                      ? "20px"
                      : "16px",
                }}
              >
                {this.state.title}
              </div>

              <div style={{ minWidth: "10px" }} />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  // minHeight: "30px",
                  fontSize:
                    this.props.isShoppingItem && this.state.width > 474
                      ? "16px"
                      : "14px",
                  fontFamily:
                    this.props.currentLang.direction === "rtl"
                      ? "IRANSansMobileBold"
                      : "SFUIDisplayBold",
                  color: "var(--green1)",
                }}
              >
                <NumericFormat
                  allowNegative={true}
                  value={this.props.price}
                  displayType={"text"}
                  thousandSeparator={true}
                />
                &nbsp;{this.props.unit}
              </div>
            </div>

            <div
              style={{
                minHeight: "1px",
                maxHeight: "1px",
                width: "100%",
                backgroundColor: "var(--gray4)",
                alignSelf: "center",
                margin: "5px 0px",
              }}
            />
            {!this.props.isShoppingItem && this.state.description && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  // height: "100%",
                  overflow: "hidden",
                  // maxHeight: "70px",
                  // height: "55px",
                  maxHeight:
                    this.props.currentLang.direction === "rtl"
                      ? "55px"
                      : "50px",
                  marginBottom: "10px",
                  // backgroundColor: "red",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div
                    className={
                      this.state.description !== ""
                        ? this.props.currentLang.direction === "rtl"
                          ? "foodItemSmallDes IRANSansMobileFont"
                          : "foodItemSmallDes SFUIDisplayFont"
                        : this.props.currentLang.direction === "rtl"
                        ? "foodItemSmallDes IRANSansMobileLightFont"
                        : "foodItemSmallDes SFUIDisplayLightFont"
                    }
                    style={{
                      color:
                        this.state.description !== ""
                          ? "var(--black1)"
                          : "var(--gray1)",
                      fontStyle:
                        this.state.description !== "" ? "normal" : "italic",
                      fontSize:
                        this.props.isShoppingItem && this.state.width > 474
                          ? "13px"
                          : "12px",
                    }}
                  >
                    <div className="foodItemSmallDesContent">
                      {this.state.description !== ""
                        ? this.state.description
                        : word[this.props.currentLang.tag]["noDescription"]}
                    </div>
                  </div>
                  {/* <div className="descriptionShadow2" /> */}
                </div>
              </div>
            )}

            {this.state.quantity > 0 && this.props.isTable && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  alignSelf: "flex-end",
                  direction: "ltr",
                }}
              >
                {!this.props.isReadOnly && (
                  <div
                    className="plusminus"
                    onClick={this.minusClick.bind(this)}
                  >
                    <img
                      src={minus}
                      style={{
                        width: "55%",
                        height: "2px",
                        objectFit: "contain",
                      }}
                      alt=""
                    />
                  </div>
                )}
                <div style={{ width: "2px" }} />
                <div
                  style={{ minWidth: "25px", maxWidth: "25px" }}
                  className={
                    this.props.currentLang.direction === "rtl"
                      ? "orderItemCount IRANSansMobileFont"
                      : "orderItemCount SFUIDisplayFont"
                  }
                >
                  {this.state.quantity !== undefined ? this.state.quantity : 0}
                </div>
                <div style={{ width: "2px" }} />
                {!this.props.isReadOnly && (
                  <div
                    className="plusminus"
                    onClick={this.plusClick.bind(this)}
                  >
                    <img
                      src={plus}
                      style={{
                        width: "55%",
                        height: "55%",
                        objectFit: "contain",
                      }}
                      alt=""
                    />
                  </div>
                )}
              </div>
            )}

            {this.state.quantity === 0 && this.props.isTable && (
              <div
                style={{
                  width: "90px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  alignSelf: "flex-end",
                }}
              >
                <CustomButton
                  title={word[this.props.currentLang.tag]["order"]}
                  fontSize="12px"
                  minHeight="30px"
                  img={null}
                  onClick={this.plusClick.bind(this)}
                />
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}
